<template>
    <div class="initcontent">
        <p class="titlename">发 起 活 动</p>
        <van-form @submit="onSubmit" :colon="true">
            <!--活动名称-->
            <van-field
                v-model="Datalist.activityName"
                name="activityName"
                label="活动名称"
                placeholder="活动名称"
                :rules="[{ required: true, message: '请填写活动名称' }]"
            />
            <!--开始时间-->
            <van-field
                readonly
                clickable
                name="activityStartTime"
                :value="Datalist.activityStartTime"
                label="开始时间"
                placeholder="点击选择日期"
                @click="showPicker = true"
                :rules="[{ required: true, message: '请填写开始时间' }]"
            />
            <van-popup v-model="showPicker" position="bottom">
                <!-- <van-datetime-picker
                    type="date"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                    :columns-order="['year', 'month', 'day' ,'hour','minute']"
                    :formatter="formatter"
                /> -->
                <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    title="选择完整时间"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                    :columns-order="['year', 'month', 'day' ,'hour','minute']"
                    :formatter="formatter"
                    />
                </van-popup>

            <!--结束时间-->
            <van-field
                readonly
                clickable
                name="activityEndTime"
                :value="Datalist.activityEndTime"
                label="结束时间"
                placeholder="点击选择日期"
                @click="showPickerend = true"
                :rules="[{ required: true, message: '请填写结束时间' }]"
            />
            <van-popup v-model="showPickerend" position="bottom">
                <!-- <van-datetime-picker
                    type="date"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirmend"
                    @cancel="showPickerend = false"
                    :columns-order="['year', 'month', 'day']"
                    :formatter="formatter"
                /> -->
                <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    title="选择完整时间"
                    :min-date="minDate"
                    :max-date="maxDate"
                   @confirm="onConfirmend"
                    @cancel="showPickerend = false"
                    :columns-order="['year', 'month', 'day' ,'hour','minute']"
                    :formatter="formatter"
                    />
                </van-popup>
            </van-popup>
            <!--部门-->
            <van-field
                readonly
                clickable
                name="activityDepartment"
                :value="Datalist.activityDepartment"
                label="发起部门"
                placeholder="请选择发起部门"
                 @click="hdbq(5)"
                :rules="[{ required: true, message: '请填写发起部门' }]"
            />
            <van-popup v-model="showPickerfqbm" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirmfqbm"
                    @cancel="showPickerfqbm = false"
                />
            </van-popup>
            <!--发起人-->
            <van-field
                v-model="Datalist.activitySponsor"
                name="activitySponsor"
                label="发  起  人"
                placeholder="发起人"
                :rules="[{ required: true, message: '请填写发起人' }]"
            />
            <!--活动类型-->
            <van-field
                readonly
                clickable
                name="activityType"
                :value="Datalist.activityType"
                label="活动类型"
                placeholder="请选择活动类型"
                 @click="hdbq(1)"
                :rules="[{ required: true, message: '请填写活动类型' }]"
            />
            <van-popup v-model="showPickerHdlx" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="columnsHdlx"
                    @confirm="onConfirmhdlx"
                    @cancel="showPickerHdlx = false"
                />
            </van-popup>
            <!--活动标签-->
            <van-field
                readonly
                clickable
                name="activityLabel"
                :value="Datalist.activityLabel"
                label="活动标签"
                placeholder="请选择活动标签"
                @click="hdbq(2)"
                :rules="[{ required: true, message: '请填写活动标签' }]"
            />
            <van-popup v-model="showPickerHdbq" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="columnsHdbq"
                    @confirm="onConfirmhdbq"
                    @cancel="showPickerHdbq = false"
                />
            </van-popup>
            <!--活动地点-->
            <van-field
                v-model="Datalist.activityPlace"
                name="activityPlace"
                label="活动地点"
                placeholder="活动地点"
                :rules="[{ required: true, message: '请填写活动地点' }]"
            />
			<!--活动人数-->
			<van-field
			    v-model="Datalist.maxUser"
			    name="activityPlace"
			    label="活动人数"
			    placeholder="活动人数"
			    :rules="[{ required: true, message: '请填写活动人数' }]"
			/>
			
			
			

            <!--活动详情-->
            <van-field
                v-model="Datalist.activityDetails"
                rows="2"
                autosize
                label="活动详情"
                type="textarea"
                maxlength="50"
                placeholder="请输入活动详情"
                show-word-limit
                :rules="[{ required: true, message: '请填写活动详情' }]"
            />

            <div class="sub">
                <van-button
                    size="normal"
                    block
                    type="info"
                    native-type="submit"
                    color="#AE1C1C"
                    >确认发布</van-button
                >
            </div>
        </van-form>
    </div>
</template>

<script>
import {
    addActivityStudent, //添加活动
	listzd
} from "../../api/api";
export default {
    data() {
        return {
            showPicker: false,
            showPickerend: false,
            showPickerHdlx: false,
            showPickerfqbm: false,
            showPickerHdbq: false,
            columns: [],
            columnsHdlx: [],
            columnsHdbq: [ ],
			zuizhonghdbq:[],
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(2021, 0, 17),
            Datalist: {
                activityName: "",
                activityStartTime: "",
                activityEndTime: "",
                activityDepartment: "",
                activitySponsor: "",
                activityType: "",
                activityLabel: "",
                activityPlace: "",
                activityDetails: "",
				maxUser:'',
            },
        };
    },
    methods: {
        onSubmit() {
			/* const list=JSON.stringify(this.zuizhonghdbq);
			this.$set(this.Datalist,'listStr',list) */
			this.$set(this.Datalist,'typeName',this.zuizhonghdbq.itemText)
			this.$set(this.Datalist,'typeCode',this.zuizhonghdbq.typeCode)
            addActivityStudent(this.Datalist).then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$toast({
                            message: res.msg,
                            forbidClick: true,
                        });
                        this.Datalist = {
                            activityName: "",
                            activityStartTime: "",
                            activityEndTime: "",
                            activityDepartment: "",
                            activitySponsor: "",
                            activityType: "",
                            activityLabel: "",
                            activityPlace: "",
                            activityDetails: "",
                        };
						setTimeout(function(){
							 this.$router.push({path:'/activity',query:{'item':1}})
						},2000)
                    }
				  
                })
                .catch(() => {});
        },
        onConfirm(time) {
            this.Datalist.activityStartTime = this.timeFormat(time);
            this.showPicker = false;
            /*判断结束时间不能小于开始时间*/
            let reg = new RegExp("-", "g");
            let start = this.Datalist.activityStartTime.replace(reg, "");
            let end = this.Datalist.activityEndTime.replace(reg, "");
            if (end !== "") {
                if (start > end) {
                    this.$toast({
                        message: "开始时间不能大于结束时间！",
                        forbidClick: true,
                    });
                    this.Datalist.activityStartTime = "";
                }
            }
        },

        onConfirmend(time) {
            this.Datalist.activityEndTime = this.timeFormat(time);
            this.showPickerend = false;
            /*判断结束时间不能小于开始时间*/
            let reg = new RegExp("-", "g");
            let start = this.Datalist.activityStartTime.replace(reg, "");
            let end = this.Datalist.activityEndTime.replace(reg, "");
            if (start > end) {
                this.$toast({
                    message: "结束时间不能小于开始时间！",
                    forbidClick: true,
                });
                this.Datalist.activityEndTime = "";
            }
        },
        onConfirmfqbm(value) {
            this.Datalist.activityDepartment = value;
            this.showPickerfqbm = false;
        },
        onConfirmhdlx(value) {
            this.Datalist.activityType = value;
            this.showPickerHdlx = false;
        },
        onConfirmhdbq(value) {
            this.Datalist.activityLabel = value.itemText;
            this.showPickerHdbq = false;
			this.zuizhonghdbq=value
        },
        formatter(type, val) {
            //日期弹窗 时间格式化
            if (type === "year") {
                return val + "年";
            }
            if (type === "month") {
                return val + "月";
            }
            if (type === "day") {
                return val + "日";
            }
            if (type === "hour") {
                return val + "时";
            }
            if (type === "minute") {
                return val + "分";
            }
            return val;
        },

        timeFormat(time) {
            // 选择后的时间格式化 2018-08-08

            let year = time.getFullYear();

            let month =
                time.getMonth() + 1 < 10
                    ? "0" + (time.getMonth() + 1)
                    : time.getMonth() + 1;

            let day =
                time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
            let Hours =
                time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
            let Minutes =
                time.getMinutes() < 10
                    ? "0" + time.getMinutes()
                    : time.getMinutes();

            return year + "-" + month + "-" + day + " " + Hours + ":" + Minutes;
        },
		//活动标签
		hdbq(val){
			if(val==1){
				this.showPickerHdlx = true
				listzd({dictId:1}).then((res)=>{
				for(var i=0;i<res.data.rows.length;i++){
					this.columnsHdlx.push(res.data.rows[i].itemText)
				}
			})
			}if(val==2){
				this.showPickerHdbq = true
				listzd({dictId:2}).then((res)=>{
				//活动标签
				this.columnsHdbq=res.data.rows
				for(var i=0;i<this.columnsHdbq.length;i++){
					this.$set(this.columnsHdbq[i],'text',this.columnsHdbq[i].itemText)
				}
			})
			}if(val==5){
				this.showPickerfqbm = true
				listzd({dictId:5}).then((res)=>{
				//活动发起部门
				for(var i=0;i<res.data.rows.length;i++){
					this.columns.push(res.data.rows[i].itemText)
				}
				
			})
			}
			
			
			
		}
    },
};
</script>

<style scoped="" lang="less">
/* .van-form{margin-top:0.5rem;} */
.van-cell {
    padding: 14px 16px;
}

.van-button--block {
    border-radius: 5px;
    font-size: 0.45rem;
    height: 1.2rem;
}

.sub {
    width: 4.09rem;
    margin: 0 auto;
    margin-top: 0.88rem;
    margin-bottom: 1.84rem;
}
.titlename {
    padding: 1rem 0 1rem 0;
    background-color: #aa0018;
    font-size: 0.5rem;
    text-align: center;
    color: #fff;
    font-weight: 600;
}
.van-form {
    overflow-y: scroll;
    height: calc(100vh - 2.34rem);
}
</style>
